/*
 * WB puppy videos
 * Puppy cards: muted, control-free video over the card image. Plays on hover
 * (mouse) or, on touch-only devices, while it is the card nearest the centre
 * of the screen (one card at a time).
 * Markup: snippets/wb-card-video.liquid. The product page video lives in
 * blocks/ai_gen_block_ab47d67.liquid.
 */
(function () {
  const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(video) {
    if (!video.src && video.dataset.src) video.src = video.dataset.src;
  }

  function play(video) {
    load(video);
    const attempt = video.play();
    if (attempt) attempt.catch(() => {});
  }

  /* ── Cards ─────────────────────────────────────────────── */
  function initCard(video) {
    if (video.dataset.wbReady) return;
    video.dataset.wbReady = 'true';
    video.addEventListener('playing', () => video.classList.add('is-playing'));

    const stop = () => stopVideo(video);

    const card = video.closest('a') || video.parentElement;
    card.addEventListener('pointerenter', (event) => event.pointerType === 'mouse' && play(video));
    card.addEventListener('pointerleave', (event) => event.pointerType === 'mouse' && stop());
    card.addEventListener('focusin', () => play(video));
    card.addEventListener('focusout', stop);

    if (centreMode) scheduleCentre();
  }

  /* ── Touch: play only the card nearest the screen centre ── */
  let centreMode = isTouch && !reduceMotion;
  let centreFrame = null;
  let centreVideo = null;

  function stopVideo(video) {
    video.pause();
    video.classList.remove('is-playing');
  }

  function pickCentre() {
    centreFrame = null;
    if (!centreMode) return;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    let best = null;
    let bestDistance = Infinity;
    document.querySelectorAll('[data-wb-card-video]').forEach((video) => {
      const rect = video.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      // Centre zone: the middle 40% of the screen height, and the card mostly on screen sideways.
      const visibleWidth = Math.min(rect.right, vw) - Math.max(rect.left, 0);
      if (Math.abs(y - vh / 2) > vh * 0.2 || visibleWidth < rect.width * 0.6) return;
      const distance = Math.hypot(x - vw / 2, y - vh / 2);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = video;
      }
    });
    if (best === centreVideo) return;
    if (centreVideo) stopVideo(centreVideo);
    centreVideo = best;
    if (best) play(best);
  }

  function scheduleCentre() {
    if (centreMode && !centreFrame) centreFrame = requestAnimationFrame(pickCentre);
  }

  // Capture catches sideways scrolling inside card carousels too.
  document.addEventListener('scroll', scheduleCentre, { capture: true, passive: true });
  window.addEventListener('resize', scheduleCentre, { passive: true });

  // A real mouse means hover mode only, even on touch-screen laptops.
  document.addEventListener(
    'pointermove',
    (event) => {
      if (event.pointerType !== 'mouse' || !centreMode) return;
      centreMode = false;
      if (centreVideo && !centreVideo.closest('a:hover')) stopVideo(centreVideo);
      centreVideo = null;
    },
    { once: true }
  );

  function init(root) {
    root.querySelectorAll('[data-wb-card-video]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  // Theme editor and section re-renders.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
